// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DistributeResultsModal-module__content___GW7Ew {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.DistributeResultsModal-module__message___EDkL5 {
  font-size: 16px;
  font-weight: 500;
  color: #375844;
  margin: 0;
}

.DistributeResultsModal-module__checkboxContainer___pKGp3 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.DistributeResultsModal-module__checkboxLabel___ppaH6 {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  font-size: 16px;
  color: #222;
}

.DistributeResultsModal-module__checkbox___NC_BS {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: #375844;
}

.DistributeResultsModal-module__buttonsContainer___D8xBS {
  display: flex;
  gap: 16px;
  padding: 16px 24px;
  border-top: 1px solid #eee;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/popups/DistributeResultsModal/DistributeResultsModal.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,0BAAA;EACA,yBAAA;AACF","sourcesContent":[".content {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.message {\n  font-size: 16px;\n  font-weight: 500;\n  color: #375844;\n  margin: 0;\n}\n\n.checkboxContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  font-size: 16px;\n  color: #222;\n}\n\n.checkbox {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: #375844;\n}\n\n.buttonsContainer {\n  display: flex;\n  gap: 16px;\n  padding: 16px 24px;\n  border-top: 1px solid #eee;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `DistributeResultsModal-module__content___GW7Ew`,
	"message": `DistributeResultsModal-module__message___EDkL5`,
	"checkboxContainer": `DistributeResultsModal-module__checkboxContainer___pKGp3`,
	"checkboxLabel": `DistributeResultsModal-module__checkboxLabel___ppaH6`,
	"checkbox": `DistributeResultsModal-module__checkbox___NC_BS`,
	"buttonsContainer": `DistributeResultsModal-module__buttonsContainer___D8xBS`
};
module.exports = ___CSS_LOADER_EXPORT___;
